"use client"

import clsx from "clsx"

import Checkbox, { type CheckboxProps } from "~/components/ui/Checkbox"

import * as css from "../styles.css"

export function BoxCheckbox({ name, value, selected, ...props }: CheckboxProps & { selected?: boolean }) {
  if (!value || typeof value !== "string" || !name) return null

  const { label } = props

  return (
    <Checkbox
      {...props}
      checkmarkActive={null}
      contentClassName={css.box}
      checkmarkClassName={clsx(css.checkmarkBox, { [css.selected]: selected })}
      labelClassName={css.labelBox}
      name={name}
      value={value}
      id={value}
    >
      {label ?? value}
    </Checkbox>
  )
}
